import { useState } from "react";
import { Input, InputGroup, InputProps, InputRightAddon } from "./index";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { IconButton } from "../../Buttons/IconButton/IconButton";

export interface PasswordInputProps {
  inputProps?: InputProps;
  "data-testid"?: string;
}
export function PasswordInput(props: PasswordInputProps) {
  const [show, setShow] = useState(false);
  const testId = props["data-testid"] || "password-input";

  return (
    <InputGroup data-testid={testId}>
      <Input {...props.inputProps} type={show ? "text" : "password"} />
      <InputRightAddon>
        <IconButton
          className="mr-3"
          onClick={() => setShow((x) => !x)}
          data-testid="password-input-toggle"
        >
          {show ? (
            <EyeIcon className="h-5 w-5 stroke-1" />
          ) : (
            <EyeOffIcon className="h-5 w-5 stroke-1" />
          )}
        </IconButton>
      </InputRightAddon>
    </InputGroup>
  );
}
